var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "handout-wrapper" }, [
    _c("p", { staticClass: "handout_title" }, [
      _c("img", {
        attrs: { src: require("../../../static/images/cancel.png"), alt: "" },
        on: { click: _vm.close }
      }),
      _vm._v(_vm._s(_vm.files.handouts_name) + "\n  ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "handout_list" },
      _vm._l(_vm.files.pdf_info, function(i) {
        return _c(
          "p",
          {
            staticClass: "open_file",
            attrs: { target: "_blank" },
            on: {
              click: function($event) {
                return _vm.preview(_vm.cid, _vm.packageid, i, _vm.files.menu_id)
              }
            }
          },
          [
            _c("img", {
              staticClass: "handout_pic",
              attrs: { src: require("../../../static/images/doc.png"), alt: "" }
            }),
            _vm._v(_vm._s(i.name))
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c99eb3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c99eb3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/handout/index.vue
// module id = null
// module chunks = 